export const TERMS_CONDITIONS_FEATURE_FLAG = 'PCC_ECTTermsAndConditions';
export const PRIVACY_POLICY_FLAG = 'PCC_ECTPrivacyPolicy';
export const CAT_LEGAL_TERMS_FLAG = 'PCC_FooterLegalTermsLinkRedirection';
export const PCC_PDP_FBT_FEATURE_FLAG = 'PCC_PDPFBTFeature';
export const PCC_HEADLESS_SAVED_LISTS_PAGE = 'PCCHeadlessSavedListsPage';
export const PCC_HEADLESS_ORDER_HISTORY_PAGE =
  'pcc-release-order-history-search-headless';
export const PCC_HEADLESS_QUOTES_PAGE = 'pcc-release-quote-search-headless';
export const PCC_HEADLESS_INVOICE_SEARCH_PAGE =
  'pcc-release-post-purchase-invoice-search';
export const PCC_CONTROL_CENTER_BLOCK_FLAG = 'PCCControlCenterFlagBlocks';
export const PCC_UPDATE_PDPCTA_TO_SEA_PARTS = 'PCC_UpdatePDPCTAToSeaParts';
export const IS_CUSTOMER_SUPPORT_ENABLE = 'isCustomerSupportEnabled';
export const PCC_HEADLESS_ADDRESS_BOOK_PAGE = 'PCCHeadlessAddressBookFeature';
export const PCC_NAVIGATION_MENU_UPDATES = 'PCCNavigationMenuUpdatesFlag';
export const PCC_HEADLESS_SAVED_LISTS_DETAIL_PAGE =
  'PCC_HeadlessSavedListsDetailsFlag';
export const PCC_CHECKOUT_FOR_CSR = 'PCCCheckoutForCSR';
export const PCC_DEALER_SHARE_QUOTE_CONFIRMATION_FLAG =
  'PCC_DealerShareQuoteConfirmationWithCustomer';
export const PCC_TAX_INFORMATION_MESSAGE_FLAG =
  'PCC_TaxInformationMessagesFlag';
export const PCC_CUSTOMER_SUPPORT_GUEST_ORDER_DETAILS_PII_REMOVAL =
  'PCC_CustomerSupportGuestOrderDetailsPIIRemoval';
export const PCC_CURRENT_CART_FLAG = 'PCC_ControlCenterBlocksCurrentCart';
export const PCC_AVAILABILITY_FOR_UNMERGED_CART_FLAG =
  'pcc-release-availability-for-unmergedcart';
export const PCC_RECENT_ORDER_FLAG = 'PCC_ControlCenterBlocksRecentOrders';
export const PCC_SAVED_LIST_FLAG = 'PCC_ControlCenterBlocksSavedLists';
export const PCC_CORE_TRACKING_FLAG = 'PCC_ControlCenterBlocksCoreTracking';
export const PCC_CUSTOMER_SUPPORT_HELP_CENTER_PAGE =
  'PCCCustomerSupportHelpCenter';
export const PCC_AVAIL_REMOVE_INTERIM_STOCK_FLAG =
  'PCC_availRemoveInterimStockFlag';
export const PCC_ASSOCIATE_EQUIPMENT_TO_SAVED_LIST =
  'PCC_AssociateEquipmentToSavedList';
export const PCC_AVAILABILITY_BY_BRANCH_LOCATION =
  'PCCHeadlessAvailabilityByBranchLocation';
export const PCC_SHARE_SAVED_LIST_DCN_SEARCH =
  'PCC_DealerUserShareSavedListDcnSearchFlag';
export const PCC_HEADLESS_CAL_ORDERS_TO_APPROVE_SEARCH_PAGE =
  'PCC_HeadlessCalOrdersToApproveSearchPage';
export const PCC_DEALER_LOCATION_FLAG = 'PCC_ECTDealerLocationFlag';
export const PCC_HEADLESS_REQUEST_SERVICE_FLAG =
  'PCCHeadlessRequestServiceFlag';
export const PCC_HIDING_MAP_FEATURE_FLAG = 'PCC_HidingMapFeatureFlag';
export const PCCHeadlessDealerMessagesFlag =
  'PCCHeadlessRedesignForDealerAndEcommerceMessagesFlag';
export const PCC_CUSTOMER_SUPPORT_DISABLE_PCC_ORDER_EMAIL =
  'PCC_CustomerSupportDisablePCCOrderEmail';
export const PCC_HIDE_METHODS_FOR_NOVICE_CUSTOMERS =
  'PCC_HideMethodsForNoviceCustomers';
export const PCC_HEADLESS_BLOCKS_CATEGORY_PAGE =
  'PCC_HeadlessBlocksCategoryPages';
export const PCC_HEADLESS_BLOCKS_PDP_TOP_SECTION =
  'PCC_HeadlessBlocksPDP_TopSection';
export const PCC_CATCARDCREDITS_TRANSLATIONS =
  'PCC_CatCardCredits_translations';
export const PCC_RELEASE_CAT_CARD_TO_CAT_COMMERICIAL_ACCOUNT =
  'pcc-release-cat-card-to-cat-commercial-account';
export const PCC_HEADLESS_SAVED_LIST_DETAILS_OPTIMIZATION_PAGE =
  'PCC_HeadlessSavedListsDetailsOptimizationFlag';
export const PCC_HEADLESS_SERVICE_INSIGHTS_CUSTOMER_FLAG =
  'PCC_CustomerAcSectionAggregatedServiceInsightsViewFlag';
export const PCC_FEDERATED_SEARCH = 'pcc-release-federated-search';
export const PCC_SEARCH_RESULTS_SPECIFICATIONS_DRAWER =
  'PCC_SearchResults_SpecificationsDrawer';
export const PCC_Headless_PDPEMURGE = 'PCC_Headless_PDPEMURGE';
export const PCC_PDP_MOBILE_STICKY_CTA = 'PCC_PDP_StickyCTAMobileView';
export const PCC_FOOTER_DESIGN_UPDATE = 'PCC_FooterDesignUpdate';
export const PCC_PDP_HEADER_UPDATE_MOBILE = 'PCC_PDP_HeaderUpdateMobileView';
export const PCC_CVR_PROMOTE_ENROLLMENT = 'PCC_CVRPromoteEnrollment';
export const PCC_CVR_IMPROVE_VISIBILITY = 'PCC_CVRImproveVisibility';
export const PCC_CAT_VANTAGE_REWARDS_FLAG = 'PCC_CatVantageRewardsFlag';
export const PCC_RELEASE_PSBH_CAT_VANTAGE_REWARDS =
  'pcc-release-psbh-cat-vantage-rewards';
export const PCC_HEADLESS_BLOCKS_SSO_PAGE = 'PCC_HeadlessBlocksSSO_Page';
export const PCC_FREQUENTLY_BOUGHT_TOGETHER = 'PCC_FrequentlyBoughtTogether';
export const PCC_SIS_TO_PCC_CART_IMPORT_FLAG = 'PCC_SIStoPCCCartImportFlag';
export const PCC_PDP_PARTS_DIAGRAM_MOBILE = 'PCC_PDP_PartsDiagramMobileView';
export const PCC_SORT_FILTER_REDESIGN_SEARCH = 'PCC_SortFilterRedesignSearch';
export const PCC_PLP_VIEW_SPECS_DRAWER = 'PCC_PLP_ViewSpecsDrawer';
export const PCC_CAT_CARD_FINANCING_OFFER_STATUS_PAGE =
  'PCC_CatCardFinancingOfferStatusPage';
export const PCC_HEADLESS_BUY_AGAIN_VIEW_ALL = 'PCCHeadlessBuyAgainViewAllFlag';
export const PCC_CATEGORY_SUBCATEGORY_ESPOT_CONTAINERS =
  'pcc-release-category-subcategory-espot-containers';
export const PCC_BLOCKS_ORDER_CONFIRMATION_PAGE_CLEANUP =
  'pcc-release-blocks-order-confirmation-page-cleanup-feature-flag';
export const PCC_SEARCH_RESULTS_MEQ_MOBILE_UPDATES =
  'PCC_SearchResults_MEQMobileUpdates';
export const PCC_PLP_MEQ_MOBILE_UPDATES = 'PCC_PLP_MEQMobileUpdates';
export const PCC_PDP_HeaderUpdateMobileView = 'PCC_PDP_HeaderUpdateMobileView';
export const PCC_HEADLESS_BLOCKS_RECENTLY_VIEWED_PAGE =
  'PCCHeadlessBlocksRecentlyViewedPage';
export const PCC_CORE_TRACKING_HEADLESS_PAGE_FEATURE_FLAG =
  'pcc-release-headless-core-tracking-page';
export const PCC_HIDE_DELIVERY_INSTRUCTIONS_PUD =
  'pcc-release-hide-delivery-instructions-pud';
export const PCC_CustomerSupport_Enable_Dealer_PostOrder_Modificationsv1 =
  'PCC_CustomerSupportEnableDealerPostOrderModificationsv1';
export const PCC_RELEASE_HEADLESS_CVR_ACCOUNT_PAGE =
  'pcc-release-headless-cvr-account-page';
export const PCC_NER_URL_MANAGMENT = 'pcc-ner-url-management';
export const PCC_ADDRESS_SEQUENCE_ASIA_LOCATION =
  'pcc-release-address-sequence-asia-location';
export const PCC_RELEASE_PCC_REMAN_REPLACEMENT =
  'pcc-release-pcc-reman-replacement';
export const PCC_RELEASE_PDP_MEQ = 'pcc-release-pdp-meq';
export const PCC_RELEASE_CURRENCY_SYMBOL_UPDATE_FOR_SAUDI_RIYAL =
  'pcc-release-currency-symbol-update-for-saudi-riyal';
export const PCC_DISCONTINUED_PARTS_INFORMATION_ON_PDP =
  'pcc-release-discontinued-parts-information-on-pdp';
export const PCC_OFFLINE_QUOTES = 'pcc-release-offline-quote';
export const PCC_HEADLESS_SECURITY_MINIMIZE_SPECIAL_CHARACTERS =
  'pcc-release-headless-minimize-special-characters';
export const PCC_CATFI_ENHANCEMENTS_P3 =
  'pcc-release-cat-fi-enhancements-phase-3';
export const PCC_CATFI_ENHANCEMENTS_P5 =
  'pcc-release-cat-fi-enhancements-phase-5';
export const PCC_RELATED_PARTS = 'pcc-release-pcc-relatedparts';
export const PCC_PROMO_CODE_DISCOUNT_MESSAGE =
  'pcc-promo-code-doc-disc-total-message';
export const PCC_HEADLESS_BLOCKS_SHOP_BY_CATEGORY_PAGE =
  'PCCHeadlessBlocksShopByCategoryPage';
export const PCC_HEADLESS_PICKUP_AND_DELIVERY =
  'pcc-release-blocks-pickup-and-delivery';
export const PCC_HEADLESS_PDP_FOLLOW_UP = 'pcc-release-headless-pdp-followup';
export const PCC_RELEASE_CUTOFF_TIME_STICKYBAR =
  'pcc-release-cutoff-time-stickybar';
export const PCC_RELEASE_HEADLESS_CART_BUY_NOW_BUTTON =
  'pcc-release-headless-cart-buy-now';
export const PCC_RELEASE_HANDLE_CART_ABANDONMENT =
  'pcc-release-handle-cart-abandonment';
export const PCC_RELEASE_STORE_LOCATION_TANDC =
  'pcc-release-pcc-storelocation-tand-c';
export const PCC_RELEASE_NAVIGATION_NAV_SCROLL =
  'pcc-release-pcc-navigation-navscroll';

export const PCC_RELEASE_ORDER_CONFIRMATION_END_USE_CODE_AND_ORDER_TYPE =
  'pcc-release-order-confirmation-end-use-code-and-order-type';
export const PCC_PROMOCODE_SHOPPINGCART = 'pcc-release-promocode-shopping-cart';
export const PCC_TRANSLATED_RESOURCES = 'pcc-release-translated-resources';
export const PCC_STORE_LOCATION_GEOLOCATIONPICKUP =
  'pcc-release-pcc-storelocation-geolocationpickup';
export const PCC_STORELOCATION_GEOLOCATIONSTATE_VISIBILITY =
  'pcc-release-pcc-storelocation-geolocationstatevisibility';
export const PCC_REMAINING_POINTS_POST_CHECKOUT =
  'pcc-release-remaining-points-credits-post-checkout';
export const PCC_PSBH_CAT_CREDITS_US_CA = 'pcc-release-psbh-cat-credits-us-ca';
export const PCC_PROMOTIONS_ENGINE = 'PCC_PROMOTIONS_ENGINE';
export const PCC_PSBH_CAT_CARD_US_CA = 'pcc-release-psbh-cat-card-us-ca';

//Store Location
export const PCC_STORE_LOCATION_LIST_VIEW_UPDATE =
  'pcc-release-pcc-storelocation-listviewupdate';
export const PCC_RELEASE_STORELOCATION_ASSOCIATED_DEALER_VIEW =
  'pcc-release-pcc-storelocation-associateddealerview';
export const PCC_STORELOCATION_CATCORP_USER =
  'pcc-release-pcc-storelocation-catcorpuser';
export const PCC_RELEASE_PHU_THAI_CONTENT_FLAG =
  'pcc-release-phu-thai-content-flag';
export const PCC_STORE_LOCATION_MAP_VIEW_UPDATE =
  'pcc-release-pcc-storelocation-mapviewupdate';
export const PCC_RELEASE_STORE_LOCATION_OPTIMIZATION =
  'pcc-release-pcc-storelocationoptimization';
// Shopping cart
export const PCC_RELEASE_HEADLESS_MINIMIZE_SPECIAL_CHARACTERS =
  'pcc-release-headless-minimize-special-characters';
export const PCC_RELEASE_HEADLESS_BLOCKS_SHOPPING_CART =
  'pcc-release-headless-blocks-shopping-cart';
export const PCC_RELEASE_HEADLESS_PANDA_SOS_SHOPPING_CART =
  'pcc-release-headless-panda-sos-shopping-cart';
export const PCC_RELEASE_HEADLESS_CREATE_NEW_SAVED_LIST_LINE_ITEM =
  'pcc-release-headless-create-new-saved-list-line-item';

//Smart Banner
export const PCC_SMART_BANNER_IOS = 'pcc-release-smart-banner-ios';
export const PCC_SMART_BANNER_ANDROID = 'pcc-release-smart-banner-android';

export const PCC_POBOX_INFORMATIVE_MESSAGE =
  'pcc-release-pobox-informative-message';

//Footer Label Links
export const PCC_RELEASE_UPDATE_FOOTER_LABEL_LINK = 'pcc-release-footer-label';
export const PCC_ASSOCIATED_DEALER_MODAL = 'pcc-release-associate-dealer-modal';
export const PCC_RELEASE_STORE_LOCATION_PIN_ENHANCEMENT =
  'pcc-release-pcc-storelocation-pinenhancement';

//Search Zero Results
export const PCC_RELEASE_SEARCH_ZERO_RESULTS =
  'pcc-release-search-zero-results';
export const PCC_FULL_MAP_VIEW = 'pcc-release-pcc-storelocation-fullmapview';
//Payment and summary
export const PCC_RELEASE_PAYMENT_AND_SUMMARY_BILLING_SETTINGS =
  'pcc-release-payment-and-summary-billing-settings';
//Change Feature Flag - PCC_HEADLESS_BLOCKS_PDP_TOP_SECTION to Launch Darkly
export const PCC_RELEASE_PDP_HEADLESS_BLOCKS =
  'pcc-release-pdp-headless-blocks';
export const PCC_REDESIGN_ZERO_RESULTS = 'pcc-redesign-zero-results';
export const PCC_FEATURE_ZERO_RESULTS_RECOMMENDATIONS =
  'pcc-feature-zero-results-recommendations';
export const PCC_AI_ASSISTANCE_HEADLESS_FLAG =
  'pcc-ai-customer-assistant-integration';
export const PCC_DEALER_USER_ACCESS_CUSTOMER_SAVEDLIST =
  'pcc-release-dealeruser-access-to-customer-savedlist';
export const PCC_RELEASE_ALP_HEADLESS_FLAG = 'pcc-release-alp-headless-flag';
export const PCC_SAVE_TO_LIST_ENHANCEMENT =
  'pcc-release-save-to-list-enhancement';
export const PCC_RELEASE_PARTS_DIAGRAM_VERSION_TWO =
  'pcc-release-partsdiagramversiontwo';
// Search SIS
export const PCC_SIS_MSDS_BLOB = 'pcc-sis-msds-blob';
export const PCC_RELEASE_FACETS_REDESIGN_FLAG =
  'pcc-search-plp-facets-redesign';
export const PCC_RELEASE_SEARCH_RANGE_SLIDER =
  'pcc-release-search-range-slider';
export const PCC_HEADLESS_SAVEDLIST_PAGE =
  'pcc-release-saved-list-details-csr-cart-links';
export const PCC_RELEASE_PARTS_DIAGRAM_SYSTEM_AND_COMPONENT_PAGE =
  'pcc-release-partsdiagram-systemcomponentpage';
export const PCC_RELEASE_CUSTOMIZE_KIT_QUANTITY =
  'pcc-release-customize-kit-quantity';
export const PCC_RELEASE_NER_ADD_EQUIPMENT_TO_MEQ =
  'pcc-release-ner-add-equipment-to-meq';
export const PCC_RELEASE_DEALER_USER_ACCESS_HEADLESS_FLAG =
  'pcc-release-dealer-users-access-to-customer-quotes';
export const PCC_RELEASE_COMPANY_NAME_ADDRESS_FIELDS =
  'pcc-release-company-name-address-fields';
export const PCC_RELEASE_HEADLESS_REFACTOR_RELATED_ALTERNATIVE_PART =
  'pcc-release-headless-refactor-alternative-part';
export const PCC_RELEASE_HEADLESS_FREQUENTLY_BOUGHT_TOGETHER =
  'pcc-release-headless-frequently-bought-together';
// Product View All
export const PCC_PRODUCTS_VIEW_ALL_API = 'pcc-products-view-all-api';
// Parts Diagram Enhancement
export const PCC_PARTS_DIAGRAM_ZOOM_IMAGE_ENHANCEMENT =
  'pcc-release-parts-diagram-zoom-image-enhancement';

// Shopping-preferences
export const PCC_HEADLESS_SHOPPING_PREFERENCES =
  'pcc-release-headless-shopping-preferences';
export const PCC_RELEASE_MIGRATE_PRICE_AND_AVAILABILITY =
  'pcc-release-migrate-price-and-availability-version';
export const PCC_RELEASE_HEADLESS_PRICE_AND_AVAILABILITY =
  'pcc-release-headless-price-and-availability';

export const PCC_RELEASE_HEADLESS_PRICE_AND_AVAILABILITY_ADDITIONAL_SECTION =
  'pcc-release-headless-price-and-availability-additional-section';
export const PCC_RELEASE_SEARCH_AND_PLP_AVAILABILITY_MESSAGE =
  'pcc-release-search-and-plp-availability-message';
export const PCC_RELEASE_SEARCH_AND_PLP_AVAILABILITY_MESSAGE_PREFERENCES =
  'pcc-release-search-and-plp-availability-message-preferences';

export const PCC_RELEASE_ENHANCED_PCC_TO_SIS_NONORDER_FLOW =
  'pcc-release-enhanced-pcc-to-sis-nonorder-parts-flow';
// Click to activate
export const PCC_RELEASE_CLICK_TO_ACTIVATE = 'pcc-release-click-to-activate';

export const PCC_RELEASE_LUCID_EQUIPMENT_ADD_FLAG =
  'pcc-release-lucid-equipment-add-flag';
export const AZURE_AD_API_FETCH =
  'pcc-release-pcc-migrate-ping-federate-to-azureid';
export const PCC_RELEASE_SSO_BLOCKS_HEADLESS =
  'pcc-release-sso-blocks-headless';
export const PCC_OPERATIONAL_COUNTRY_FIRST_FEATURE_FLAG =
  'pcc-operational-country-first-feature-flag';
export const PCC_RELEASE_MULTIPLE_PART_DIAGRAMS =
  'pcc-release-multiple-part-diagrams';
export const PCC_RELEASE_FEDERATED_FAST_FOLLOW =
  'pcc-release-federated-fast-follow';
export const PCC_RELEASE_CAT_INTERACT_RS_FLAG =
  'pcc-release-cat-interact-rs-flag';
export const PCC_RELEASE_ALP_ENABLE_SOFT_NAVIGATION =
  'pcc-release-alp-enable-soft-navigation';

// Headless Tax Modal
export const PCC_RELEASE_HEADLESS_TAX_MODAL = 'pcc-release-headless-tax-modal';
